import React from 'react';

export default function DebugPage({ app, sha, environment }) {
  return (
    <main style={{ padding: '2rem' }}>
      <h1>Build information</h1>
      <dl>
        <dt>App</dt><dd>{app}</dd>
        <dt>Environment</dt><dd>{environment}</dd>
        <dt>Commit</dt><dd><code>{sha}</code></dd>
      </dl>
    </main>
  );
}
